import React from 'react';
import CareLineHeader from './CareLineHeader';
import CareLineFooter from './CareLineFooter';

const CareLineLayout = ({
    children,
    activePage,
    logo,
    clinicName,
    slug = null,
    primaryColor,
}) => {
    return (
        <div className="min-h-screen bg-white font-jakarta flex flex-col">
            <CareLineHeader
                activePage={activePage}
                logo={logo}
                clinicName={clinicName}
                slug={slug}
                primaryColor={primaryColor}
            />
            <main className="flex-1 w-full min-h-0">{children}</main>
            <CareLineFooter />
        </div>
    );
};

export default CareLineLayout;
